import coorPlot from "../../../../content/posts/data-release-notes/modbases/coorplot.jsx";
import coverPlot from "../../../../content/posts/data-release-notes/modbases/coverplot.jsx";
import * as React from 'react';
export default {
  coorPlot,
  coverPlot,
  React
};